const removeLastParagraph = (htmlString) => {
  const arr = htmlString.split('\n');

  arr.pop();

  return arr.join('\n');
};

export default removeLastParagraph;
